import {create} from 'zustand';
import {ChatErrorSnackbarStore} from '../types';

export const useChatErrorSnackbarStore = create<ChatErrorSnackbarStore>(set => ({
	open: false,
	setOpen: open => set({open}),
}));
